import { ArrowLeft } from 'phosphor-react'
import { FC } from 'react'

import logoblack from 'src/assets/product-config/logo-black.png'
import CreateWalletPhoneFrameSVG from '../../../assets/CreateWalletPhoneFrameSVG.svg'
import GooglePlayAppButton from '../../../assets/android.png'
import AppleAppButton from '../../../assets/ios.png'

interface PhoneFrameProps {
  onPress?: () => void
}

export const PhoneFrame: FC<PhoneFrameProps> = ({ onPress }) => {
  return (
    <div className="h-full w-full max-w-[40%] flex flex-col items-center justify-center">
      <div className="flex items-center justify-start gap-3 w-full">
        <div>
          <button
            onClick={onPress}
            className="w-14 h-14 bg-black rounded-xl flex items-center justify-center inner-container"
          >
            <ArrowLeft weight="bold" color="white" size={26} />
          </button>
        </div>

        <img className="w-[20%] h-[70%]" src={logoblack} alt="" />
      </div>

      <img
        className="w-[60%] h-[40%] max-2xl:w-[55%] max-2xl:h-[65%]"
        src={CreateWalletPhoneFrameSVG}
        alt=""
      />

      <div className="flex items-center my-4">
        <button>
          <img
            className="w-[80%] h-[80%] max-2xl:w-[50%] max-2xl:h-[50%]"
            src={GooglePlayAppButton}
            alt=""
          />
        </button>
        <button>
          <img
            className="w-[80%] h-[80%] max-2xl:w-[50%] max-2xl:h-[50%]"
            src={AppleAppButton}
            alt=""
          />
        </button>
      </div>

      <p className="font-extralight text-white text-lg max-2xl:text-xs">
        Copyright © 2024 - Vilapay - Todos os direitos reservados
      </p>
    </div>
  )
}
